import { Component, inject, computed } from '@angular/core';
import { TenantService, UserService } from '../../core';
import { CommonModule } from '@angular/common';
import { Button } from 'primeng/button';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TranslatePipe } from '@/app/layout/pipes/translate.pipe';
import { TodoTaskService } from '../../core/service/todoTask.service';
import { EntrepriseOptionService } from '../../core/service/entrepriseOption.service';
import { EntrepriseOptionsEnum } from '../../core/models/enums/entrepriseOption.enum';

@Component({
  selector: 'app-todolist',
  standalone: true,
  imports: [
    CommonModule,
    Button,
    ConfirmDialog,
    TranslatePipe
  ],
  templateUrl: './todolist.component.html',
  styleUrls: ['./todolist.component.scss'],
  providers: [ConfirmationService]
})
export class TodolistComponent {
  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  #todoTaskService = inject(TodoTaskService);

  #listTaskQuery = this.#todoTaskService.getListTasks();
  #listInformationsQuery = this.#todoTaskService.getListInformations();

  listTasks = computed(() => this.#listTaskQuery.data() ?? []);
  listInformations = computed(() => this.#listInformationsQuery.data() ?? []);

  checkedOne = false;
  checkedTwo = false;

  visible: boolean = false;

  tenantService = inject(TenantService);
  userService = inject(UserService);
  #entrepriseOptionsService = inject(EntrepriseOptionService);

  #entrepriseOptionsQuery =
      this.#entrepriseOptionsService.listEntrepriseOptions();
  #userQuery = this.userService.getUserInfos();

  userInfosExternalLinksLength = computed(() => this.#userQuery.data()?.externalLinks?.length ?? 0);
  hasNoExternalLinks = computed(
    () => (this.#userQuery.data()?.externalLinks?.length ?? 0) === 0
  )
  linkApplicationEnabled = computed(() => {
    let data = this.#entrepriseOptionsQuery.data() ?? [];
    let x =
      data.find((x: any) => x.key.toLowerCase() == EntrepriseOptionsEnum.LinkApplicationEnabled.toLowerCase())?.value ??
      false;
    return x.toString().toLowerCase() === 'true';
  });

  showDialog() {
      this.visible = true;
  }

  checkedOneChange() {
    this.checkedOne = !this.checkedOne;
  }

  checkedTwoChange() {
    this.checkedTwo = !this.checkedTwo;
  }

  changeTaskRealisee(id: string) {
    var task = this.listTasks().filter(x => x.id == id)[0]
    if (!task.realisee){
      this.confirmationService.confirm({
        message: 'Avez-vous terminé cette tache ?',
        header: 'Confirmation',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
          task.realisee = !task.realisee;
          this.#todoTaskService.updateTaskRealisee.mutate(
            { id, task }, {
            onSuccess: () => {
              this.messageService.add({ key: 'global', severity: 'success', summary: 'Succès', detail: 'Tache marquée comme réalisée !' });
            },
            onError: (error) => {
              this.messageService.add({ key: 'global', severity: 'error', summary: 'Erreur', detail: error.message });
            }
        });
        }
      });
    }
  }

}
